/**
 * "What is Buffer / how to get your token" explainer callout. Shared by the
 * onboarding Buffer step and the channel-aware Settings → Scheduling card so
 * the copy lives in one place. Yellow-accent box, same visual language as the
 * cookies "how to export" callout.
 */
import { ExternalLink } from "lucide-react";

export function BufferExplainer(): React.JSX.Element {
  return (
    <div
      style={{
        border: "1px solid rgba(255,213,0,.22)",
        background: "rgba(255,213,0,.05)",
        borderRadius: 14,
        padding: "16px 18px",
        fontSize: 13,
        lineHeight: 1.55,
        color: "var(--ql-fg-muted)",
      }}
    >
      <div style={{ fontWeight: 600, color: "var(--ql-fg)", marginBottom: 8 }}>
        What is Buffer, and where do I get the token?
      </div>
      <p style={{ margin: "0 0 10px" }}>
        <strong>Buffer</strong> is the scheduling service that actually publishes your posts to
        Instagram, LinkedIn, Pinterest, and the rest. Connecting it here lets this channel
        schedule its finished videos and posts straight to <em>its own</em> Buffer account —
        each channel targets a different brand.
      </p>
      <div style={{ fontWeight: 600, color: "var(--ql-fg)", margin: "0 0 6px" }}>Get your token in 4 steps:</div>
      <ol style={{ margin: "0 0 10px", paddingInlineStart: 20 }}>
        <li>Sign in to the Buffer account for <strong>this brand</strong>.</li>
        <li>Open <strong>Account → Apps &amp; Extras → Create Access Token</strong> (or the API page below).</li>
        <li>Create a personal access token and copy it.</li>
        <li>Paste it in the field here — we validate it against Buffer before saving.</li>
      </ol>
      <a
        href="https://publish.buffer.com/account/apps"
        target="_blank"
        rel="noreferrer"
        style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--ql-accent, #FFD500)", textDecoration: "none", fontWeight: 600 }}
      >
        Open publish.buffer.com → Account → API <ExternalLink size={13} />
      </a>
      <div style={{ marginTop: 10, fontSize: 12, color: "var(--ql-fg-subtle)" }}>
        Stored locally (chmod 600), one credentials file per channel. You can skip this and connect
        later in Settings → Scheduling.
      </div>
    </div>
  );
}
